import { render, staticRenderFns } from "./CertificateSetupModal.vue?vue&type=template&id=7f0fc0e2&scoped=true&"
import script from "./CertificateSetupModal.vue?vue&type=script&lang=ts&"
export * from "./CertificateSetupModal.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateSetupModal.vue?vue&type=style&index=0&id=7f0fc0e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0fc0e2",
  null
  
)

export default component.exports